import { Pipe, PipeTransform } from '@angular/core';
import { currencyParser } from '../helpers/currency-parser';

@Pipe({
  standalone: false,
  name: 'currencyFormat',
  pure: false
})
export class CurrencyFormatPipe implements PipeTransform {

  public transform(item: any, prefix = '') {
    return currencyParser(item, prefix);
  }
}
